import React from 'react';
// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { ContactsOutlined } from '@ant-design/icons';

// icons
const icons = {
    ContactsOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const devicesManager = {
    id: 'devices',
    title: <FormattedMessage id="devices" />,
    type: 'group',
    children: [
        {
            id: 'devices',
            title: <FormattedMessage id="devices" />,
            type: 'item',
            url: '/devices',
            icon: icons.ContactsOutlined
        }
    ]
};

export default devicesManager;
